import { Guid } from 'guid-typescript'
import _ from 'lodash'
import { HierarchyModel } from './HierarchyModel'

export interface IFilterModel {
  id: string
}

type ValueOrFactory<T> = T | (() => T)
type PartialValueOrFactory<T> = {
  [P in keyof T]?: ValueOrFactory<T[P]>
}

export class FilterModel implements IFilterModel {
  private _name: ValueOrFactory<string>
  private _displayName: ValueOrFactory<string>
  private _operation: ValueOrFactory<string>
  private _filtervisual: ValueOrFactory<string>
  private _table: ValueOrFactory<string>
  private _defaultValue: ValueOrFactory<string>
  private _values: ValueOrFactory<HierarchyModel[]>

  get id(): string {
    return Guid.create().toString()
  }

  get name(): string {
    return this.getValue(this._name)
  }

  get displayName(): string {
    return this.getValue(this._displayName)
  }

  get operation(): string {
    return this.getValue(this._operation)
  }

  get filtervisual(): string {
    return this.getValue(this._filtervisual)
  }

  get table(): string {
    return this.getValue(this._table)
  }

  get defaultValue(): string {
    return this.getValue(this._defaultValue)
  }

  get values(): HierarchyModel[] {
    return this.getValue(this._values)
  }

  constructor(init?: PartialValueOrFactory<FilterModel>) {
    ;(Object as any).assign(
      this,
      _.mapKeys(init, (_value: any, key: string) => '_' + key)
    )
  }

  private getValue<T>(value: ValueOrFactory<T>): T {
    if (value instanceof Function) {
      return value()
    }

    return value
  }
}
